import { trigger, transition, style, animate } from '@angular/animations';
import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter, HostBinding } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { GoMaterialModule } from '@go-modules/go-material.module';

type IconType = 'ficon-arrow-down' | 'ficon-arrow-up';
export type ScrollDirectionType = 'up' | 'down' | null;

@Component({
	selector: 'jump-to-current-time-button',
	templateUrl: 'jump-to-current-time.component.html',
	styleUrls: ['./jump-to-current-time.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		TranslateModule,
		GoMaterialModule
	],
	animations: [
		trigger('fadeInScale', [
			transition(':enter', [
				style({ opacity: 0, transform: 'scale(0.8)' }),
				animate('150ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
			]),
			transition(':leave', [
				animate('150ms ease-in', style({ opacity: 0, transform: 'scale(0.8)' }))
			])
		])
	]
})
export class JumpToCurrentTimeComponent {
	@Input() public scrollDirection: ScrollDirectionType = null;
	@Input() public hasTags = false;
	@Output() public jumpToCurrentTime = new EventEmitter<void>();

	@HostBinding('style.bottom')
	public get bottomPosition (): string {
		return this.hasTags ? '130px' : '80px';
	}

	public get icon (): IconType {
		return this.scrollDirection === 'up' ? 'ficon-arrow-up' : 'ficon-arrow-down';
	}

	public onClick (): void {
		this.jumpToCurrentTime.emit();
	}
}
